<template>
  <div class="content-wrapper">
    <app-breadcrumb
      page-title="Formularios"
      directory="Compromiso de Cumplimiento"
      :icon="'pie-chart'"
    />
    <div class="row">
      <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
          <div class="card-header p-primary bg-transparent">
            <h5 class="card-title m-0">Etiquetas</h5>
          </div>
          <app-overlay-loader v-if="preloader" />
          <div class="card-body">
            <form
              ref="form"
              data-url="/accreditations/forms/tags"
              class="mb-0"
              :class="{ 'loading-opacity': preloader }"
            >
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Área de Acreditación</label>
                    <app-input
                      type="select"
                      v-model="inputs.accreditation_area_id"
                      :list="areas"
                      :required="true"
                      :disabled="preloader"
                      v-on:change="onChangeFields"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Actividad</label>
                    <app-input
                      type="select"
                      v-model="inputs.accreditation_activity_id"
                      :list="activities"
                      :required="true"
                      :disabled="preloader"
                      v-on:change="onChangeFields"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Tipo de Acreditación</label>
                    <app-input
                      type="select"
                      v-model="inputs.accreditation_type_id"
                      :list="types"
                      :required="true"
                      :disabled="preloader"
                      v-on:change="onChangeFields"
                    />
                  </div>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Version</label>
                    <app-input
                      type="select"
                      v-model="inputs.version_id"
                      :list="versions"
                      :required="true"
                      :disabled="preloader"
                      v-on:change="onChangeFields"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Etiquetas</label>
                    <app-input
                      type="select"
                      v-model="inputs.tag"
                      :list="tags"
                      :disabled="preloader"
                      v-on:change="onChangeTag"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nombre</label>
                    <app-input
                      type="text"
                      v-model="inputs.name"
                      :required="true"
                      :disabled="preloader"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Texto</label>
                    <quill-editor
                      v-model="inputs.text"
                      :options="editorOption"
                      style="background: white; color: black"
                    />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
              <div class="row">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-primary mr-2"
                    @click.prevent="submit"
                    :disabled="preloader"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { quillEditor } from "vue-quill-editor";

export default {
  mixins: [FormMixin],
  components: { quillEditor },
  data() {
    return {
      preloader: false,
      inputs: {
        id: null,
        accreditation_area_id: null,
        accreditation_activity_id: null,
        accreditation_type_id: 1,
        tag: null,
        name: null,
        text: null,
        version_id: null,
      },
      accreditationAreaList: [],
      accreditationActivityList: [],
      accreditationTypeList: [],
      tagList: [],
      editorOption: {
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            [{ align: [] }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ color: [] }, { background: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
          ],
        },
        theme: "snow", // snow or bubble
      },
    };
  },
  computed: {
    areas() {
      let tmp = [{ id: null, value: "Seleccione una opción" }];
      if (this.$store.state.accreditation.accAppOptions != null) {
        tmp = [
          ...tmp,
          ...this.$store.state.accreditation.accAppOptions.accreditationAreas.filter(
            (item) => {
              return { id: item.id, value: item.value };
            }
          ),
        ];
      }
      return tmp;
    },
    activities() {
      let tmp = [{ id: null, value: "Seleccione una opción" }];
      if (
        this.$store.state.accreditation.accAppOptions != null &&
        this.inputs.accreditation_area_id != null
      ) {
        tmp = [
          ...tmp,
          ...this.$store.state.accreditation.accAppOptions.accreditationActivities.filter(
            (item) => {
              if (item.parent == this.inputs.accreditation_area_id)
                return { id: item.id, value: item.value };
            }
          ),
        ];
      }
      return tmp;
    },
    types() {
      let tmp = [{ id: null, value: "Seleccione una opción" }];
      if (this.$store.state.accreditation.accAppOptions != null) {
        tmp = [
          ...tmp,
          ...this.$store.state.accreditation.accAppOptions.accreditationTypes.filter(
            (item) => {
              return { id: item.id, value: item.value };
            }
          ),
        ];
      }
      return tmp;
    },
    tags() {
      let tmp = [{ id: null, value: "Seleccione una opción" }, ...this.tagList];

      return tmp;
    },
    versions() {
      return this.$store.getters.getVersions();
    },
  },
  created() {
    this.$store.dispatch("getAccAppOptions");
    this.$store.dispatch("getVersions");
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.inputs.type = 'CC';
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s("Guardado con éxito");
      const { data } = res.data;

      let inputs = {};
      inputs.id = data.id;
      inputs.accreditation_area_id = data.accreditation_area_id;
      inputs.accreditation_activity_id = data.accreditation_activity_id;
      inputs.accreditation_type_id = data.accreditation_type_id;
      inputs.name = data.name;
      inputs.text = data.text;
      inputs.tag = data.id;
      inputs.version_id = data.version_id;

      this.inputs = inputs;
      this.getTags(inputs);
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      const { data } = res;
      this.$toastr.e(data.message);
    },
    onChangeFields() {
      if (
        this.inputs.accreditation_area_id != null &&
        this.inputs.accreditation_activity_id != null &&
        this.inputs.accreditation_type_id != null &&
        this.inputs.version_id != null
      ) {
        this.inputs.tag = null;
        this.inputs.name = null;
        this.tagList = [];
        this.getTags(this.inputs);
      }
    },
    getTags(data) {
      this.preloader = true;
      let url = "/accreditations/forms/tags/list";
      let params = new URLSearchParams(data).toString();

      this.axiosGet(`${url}?${params}`)
        .then((res) => {
          this.tagList = res.data.filter(item => item.type === 'CC');
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    onChangeTag() {
      if (this.inputs.tag != null && this.inputs.tag != "") {
        this.tagList.filter((item) => {
          if (item.id == this.inputs.tag) {
            this.inputs.id = item.id;
            this.inputs.name = item.value;
            this.inputs.text = item.text;
          }
        });
      } else {
        this.inputs.id = null;
        this.inputs.name = null;
        this.inputs.text = null;
      }
    },
  },
};
</script>
